import { render, staticRenderFns } from "./AppFooterMenuItemSocialMedia.vue?vue&type=template&id=ad9af456&scoped=true&"
import script from "./AppFooterMenuItemSocialMedia.vue?vue&type=script&lang=ts&"
export * from "./AppFooterMenuItemSocialMedia.vue?vue&type=script&lang=ts&"
import style0 from "./AppFooterMenuItemSocialMedia.vue?vue&type=style&index=0&id=ad9af456&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad9af456",
  null
  
)

export default component.exports